var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _g3, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g4, _ellipse, _path27, _path28, _path29, _path30, _path31, _g5, _path32, _g6, _ellipse2, _path33, _path34, _g7, _rect, _g8, _path35, _path36, _path37, _g9, _path38, _g0, _rect2, _path39, _path40, _path41, _path42, _path43, _circle, _path44, _path45, _path46, _path47, _path48, _path49, _g1, _path50, _path51, _g10, _path52, _path53, _g11, _path54, _path55, _g12, _path56, _path57, _g13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraduateCharacter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 317,
    viewBox: "0 0 231 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.231 225.904C203.445 212.527 176.413 190.719 160.13 186.243C119.171 174.983 136.36 209.847 147.727 217.357C156.782 223.34 184.065 248.463 196.231 225.904Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5442 226.686C44.1677 223.833 24.8679 202.893 18.54 196.312L45.8761 171.508L72.805 190.3L104.851 193.782L103.377 229.074C90.7008 229.074 80.448 230.565 59.5442 226.686Z",
    fill: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_604_11485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 171,
    width: 87,
    height: 59
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5442 226.686C44.1677 223.833 24.8679 202.893 18.54 196.312L45.8761 171.508L72.805 190.3L104.851 193.782L103.377 229.074C90.7008 229.074 80.448 230.565 59.5442 226.686Z",
    fill: "#946555"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_604_11485)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_604_11485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.08 248.683C54.0461 249.923 63.1249 242.803 64.358 232.779C65.591 222.755 58.5115 213.624 48.5453 212.384C38.5792 211.144 29.5004 218.264 28.2673 228.288C27.0343 238.311 34.1138 247.443 44.08 248.683Z",
    fill: "#666666"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215.72 40.8655C208.34 33.1902 196.629 32.1966 188.125 38.029C187.54 28.0907 180.061 19.5874 169.822 18.0787C159.991 16.6344 150.745 22.0927 146.992 30.7983C144.671 21.2341 135.971 14.2272 125.714 14.4174C113.862 14.6504 104.442 24.4477 104.675 36.2995L105.218 63.8731C105.448 75.5808 115.012 84.915 126.671 84.915C126.815 84.915 126.959 84.915 127.103 84.912C133.865 84.7801 139.832 81.5297 143.671 76.562C146.753 82.4282 152.496 86.7948 159.552 87.8343C160.613 87.9907 161.665 88.0643 162.705 88.0643C162.947 88.0643 163.189 88.0551 163.431 88.049C163.882 88.6285 164.37 89.1897 164.888 89.7294C169.101 94.1144 174.728 96.3192 180.364 96.3192C186 96.3192 191.075 94.329 195.237 90.3273L215.116 71.2141C223.663 62.9991 223.929 49.4086 215.714 40.8624L215.72 40.8655Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_604_11485",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 14,
    width: 118,
    height: 65
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.103 78.9907L215.192 71.2141C223.738 62.9991 224.005 49.4086 215.79 40.8624C208.409 33.1871 196.698 32.1936 188.195 38.026C187.609 28.0876 180.13 19.5843 169.891 18.0756C160.06 16.6313 150.815 22.0896 147.061 30.7953C144.74 21.2341 136.041 14.2272 125.783 14.4174C113.932 14.6504 104.511 24.4477 104.744 36.2995L105.027 50.5953C110.828 49.9759 116.796 49.6631 122.889 49.6631C157.699 49.6631 188.474 59.8713 207.103 78.9907Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_604_11485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.695 19.8853C112.008 62.466 187.789 85.9243 223.228 48.2714L228.506 91.5697L80.8838 71.1042L103.695 19.8853Z",
    fill: "#FAFAFA"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M230.481 128.433C230.481 177.242 184.392 197.569 127.54 197.569C70.6883 197.569 24.5996 177.242 24.5996 128.433C24.5996 79.6242 70.6883 52.4033 127.54 52.4033C184.392 52.4033 230.481 79.6242 230.481 128.433Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M230.481 128.433C230.481 177.242 184.392 197.569 127.54 197.569C70.6883 197.569 24.5996 177.242 24.5996 128.433C24.5996 79.6242 70.6883 52.4033 127.54 52.4033C184.392 52.4033 230.481 79.6242 230.481 128.433Z",
    fill: "url(#paint0_linear_604_11485)",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M201.87 133.42C201.87 167.893 168.593 184.418 127.543 184.418C86.492 184.418 53.2148 167.893 53.2148 133.42C53.2148 98.947 86.492 81.8853 127.543 81.8853C168.593 81.8853 201.87 98.9439 201.87 133.42Z",
    fill: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_604_11485",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 81,
    width: 149,
    height: 104
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M201.87 133.421C201.87 167.894 168.593 184.419 127.543 184.419C86.492 184.419 53.2148 167.894 53.2148 133.421C53.2148 98.9475 86.492 81.8857 127.543 81.8857C168.593 81.8857 201.87 98.9444 201.87 133.421Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_604_11485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1748 179.185C91.1296 179.185 102.442 167.872 102.442 153.917C102.442 139.963 91.1296 128.65 77.1748 128.65C63.2199 128.65 51.9072 139.963 51.9072 153.917C51.9072 167.872 63.2199 179.185 77.1748 179.185Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.908 179.185C191.863 179.185 203.176 167.872 203.176 153.917C203.176 139.962 191.863 128.65 177.908 128.65C163.953 128.65 152.641 139.962 152.641 153.917C152.641 167.872 163.953 179.185 177.908 179.185Z",
    fill: "#8D8D8D"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M108.639 128.725C104.144 133.221 98.4495 134.818 94.2577 130.626C90.0659 126.435 91.6635 120.743 96.1589 116.245C100.654 111.749 106.349 110.152 110.541 114.344C114.732 118.535 113.135 124.227 108.639 128.725Z",
    fill: "#434343"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M110.911 141.232C106.415 145.728 100.721 147.325 96.5292 143.134C92.3374 138.942 93.935 133.25 98.4304 128.752C102.926 124.257 108.62 122.659 112.812 126.851C117.004 131.043 115.406 136.734 110.911 141.232Z",
    fill: "#434343"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.995 123.761C101.885 125.871 99.3953 126.806 97.8068 125.217C96.2184 123.629 97.1506 121.139 99.2634 119.029C101.373 116.92 103.863 115.984 105.452 117.573C107.04 119.161 106.108 121.651 103.995 123.761Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.547 138.402C104.634 140.316 102.303 141.092 100.715 139.503C99.1262 137.915 99.902 135.584 101.816 133.671C103.729 131.757 106.059 130.981 107.648 132.57C109.236 134.158 108.46 136.489 106.547 138.402Z",
    fill: "#D3D3D3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.453 128.422C106.545 129.33 105.416 129.67 104.61 128.863C103.803 128.057 104.144 126.925 105.051 126.021C105.959 125.116 107.088 124.773 107.894 125.579C108.701 126.386 108.36 127.517 107.453 128.422Z",
    fill: "#8D8D8D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.648 128.725C152.153 133.22 146.458 134.818 142.266 130.626C138.075 126.434 139.672 120.743 144.168 116.244C148.663 111.746 154.357 110.151 158.549 114.343C162.741 118.535 161.144 124.226 156.648 128.725Z",
    fill: "#434343"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M158.922 141.232C154.426 145.727 148.732 147.325 144.54 143.133C140.348 138.941 141.946 133.25 146.441 128.751C150.937 124.256 156.631 122.658 160.823 126.85C165.015 131.042 163.417 136.733 158.922 141.232Z",
    fill: "#434343"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M152.008 123.76C149.898 125.87 147.408 126.805 145.82 125.216C144.231 123.628 145.163 121.138 147.276 119.028C149.386 116.919 151.876 115.983 153.464 117.572C155.053 119.16 154.12 121.65 152.008 123.76Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.559 138.402C152.645 140.315 150.315 141.091 148.726 139.503C147.138 137.914 147.914 135.584 149.827 133.67C151.741 131.757 154.071 130.981 155.66 132.569C157.248 134.158 156.472 136.488 154.559 138.402Z",
    fill: "#D3D3D3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M155.464 128.421C154.557 129.329 153.428 129.669 152.622 128.863C151.815 128.056 152.156 126.925 153.063 126.02C153.971 125.113 155.099 124.772 155.906 125.579C156.712 126.385 156.372 127.517 155.464 128.421Z",
    fill: "#8D8D8D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M132.119 143.359C132.101 143.359 132.086 143.359 132.067 143.359C130.488 143.344 128.97 142.577 127.538 141.075C126.106 142.577 124.588 143.344 123.009 143.359C122.994 143.359 122.975 143.359 122.957 143.359C120.507 143.359 119.022 141.535 118.86 141.326C118.342 140.658 118.464 139.695 119.133 139.173C119.798 138.658 120.755 138.775 121.273 139.434C121.307 139.474 122.003 140.293 122.96 140.293C122.972 140.293 122.984 140.293 122.997 140.293C123.941 140.271 125.024 139.471 126.13 137.981C126.419 137.591 126.876 137.361 127.36 137.361H127.704C128.188 137.361 128.645 137.591 128.933 137.981C130.04 139.471 131.123 140.271 132.067 140.293C132.079 140.293 132.092 140.293 132.104 140.293C133.079 140.293 133.784 139.443 133.79 139.434C134.309 138.766 135.269 138.649 135.937 139.167C136.605 139.685 136.722 140.654 136.204 141.326C136.041 141.535 134.557 143.359 132.107 143.359H132.119Z",
    fill: "#434343"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M167.304 152.076C166.912 152.076 166.519 151.926 166.219 151.628C165.621 151.03 165.621 150.058 166.219 149.46L172.772 142.907C173.37 142.309 174.342 142.309 174.94 142.907C175.538 143.505 175.538 144.477 174.94 145.075L168.387 151.628C168.086 151.929 167.694 152.076 167.301 152.076H167.304Z",
    fill: "#747474"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M175.558 152.076C175.166 152.076 174.773 151.925 174.473 151.628C173.875 151.03 173.875 150.058 174.473 149.46L178.272 145.661C178.87 145.063 179.842 145.063 180.44 145.661C181.038 146.259 181.038 147.231 180.44 147.829L176.641 151.628C176.34 151.928 175.948 152.076 175.555 152.076H175.558Z",
    fill: "#747474"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M179.357 148.277C178.965 148.277 178.572 148.127 178.272 147.83C177.674 147.232 177.674 146.26 178.272 145.662L181.028 142.905C181.626 142.307 182.598 142.307 183.196 142.905C183.794 143.503 183.794 144.475 183.196 145.073L180.44 147.83C180.139 148.13 179.747 148.277 179.354 148.277H179.357Z",
    fill: "#747474"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M183.81 152.076C183.418 152.076 183.025 151.926 182.725 151.628C182.127 151.03 182.127 150.058 182.725 149.46L189.278 142.907C189.876 142.309 190.848 142.309 191.446 142.907C192.044 143.505 192.044 144.477 191.446 145.075L184.893 151.628C184.592 151.929 184.2 152.076 183.807 152.076H183.81Z",
    fill: "#747474"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7156 152.076C64.3231 152.076 63.9306 151.926 63.6301 151.628C63.0322 151.03 63.0322 150.058 63.6301 149.46L70.1831 142.907C70.7811 142.309 71.7531 142.309 72.3511 142.907C72.9491 143.505 72.9491 144.477 72.3511 145.075L65.7981 151.628C65.4976 151.929 65.1051 152.076 64.7126 152.076H64.7156Z",
    fill: "#747474"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9705 152.076C72.578 152.076 72.1855 151.926 71.885 151.628C71.287 151.03 71.287 150.058 71.885 149.46L75.6843 145.661C76.2823 145.063 77.2544 145.063 77.8523 145.661C78.4503 146.259 78.4503 147.231 77.8523 147.829L74.053 151.628C73.7525 151.929 73.36 152.076 72.9675 152.076H72.9705Z",
    fill: "#747474"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7664 148.277C76.3739 148.277 75.9814 148.127 75.6809 147.83C75.0829 147.232 75.0829 146.26 75.6809 145.662L78.4376 142.905C79.0356 142.307 80.0077 142.307 80.6056 142.905C81.2036 143.503 81.2036 144.475 80.6056 145.073L77.8489 147.83C77.5484 148.13 77.1559 148.277 76.7634 148.277H76.7664Z",
    fill: "#747474"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2215 152.076C80.829 152.076 80.4365 151.926 80.136 151.628C79.538 151.03 79.538 150.058 80.136 149.46L86.689 142.907C87.2869 142.309 88.259 142.309 88.857 142.907C89.4549 143.505 89.4549 144.477 88.857 145.075L82.3039 151.628C82.0034 151.929 81.6109 152.076 81.2184 152.076H81.2215Z",
    fill: "#747474"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_604_11485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.539 192.682C166.539 192.682 166.27 193.206 165.791 194.157L164.706 186.849L127.543 193.804L90.3812 186.849L89.2956 194.157C88.8173 193.206 88.5474 192.682 88.5474 192.682C88.5474 192.682 79.1925 210.315 82.2666 240.975C82.5726 244.027 100.492 279.925 104.495 260.977C106.781 267.765 98.8732 247.327 106.583 250.11C115.415 253.299 109.638 257.651 109.362 250.11L127.543 263.98L145.724 250.11C145.448 257.651 149.949 256.333 158.781 253.147C189.326 242.12 166.539 192.682 166.539 192.682Z",
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.6945,
    cy: 194.702,
    rx: 20.8297,
    ry: 23.5106,
    transform: "rotate(-73.9599 35.6945 194.702)",
    fill: "#B5B5B5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6893 113.711L0.361328 125.06L18.8806 168.793L27.7818 215.141C27.7905 215.24 27.8091 215.337 27.8378 215.432L27.838 215.433L27.8382 215.433C27.8382 215.433 27.8382 215.433 27.8382 215.433C28.6732 218.18 37.7062 217.865 48.014 214.732C58.3219 211.598 66.0012 206.831 65.1662 204.084C65.137 203.988 65.0978 203.896 65.0488 203.808L46.6467 160.351L37.6893 113.711Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6893 113.711L0.361328 125.06L18.8806 168.793L27.7818 215.141C27.7905 215.24 27.8091 215.337 27.8378 215.432L27.838 215.433L27.8382 215.433C27.8382 215.433 27.8382 215.433 27.8382 215.433C28.6732 218.18 37.7062 217.865 48.014 214.732C58.3219 211.598 66.0012 206.831 65.1662 204.084C65.137 203.988 65.0978 203.896 65.0488 203.808L46.6467 160.351L37.6893 113.711Z",
    fill: "url(#paint1_linear_604_11485)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7793 197.188C27.1117 185.908 30.1071 170.789 32.4505 165.059C30.0609 172.813 35.4273 188.568 38.4091 195.476C37.8147 195.349 36.1599 193.805 35.0593 194.14C33.6544 194.567 33.1086 196.132 32.7793 197.188Z",
    fill: "#707070"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9067 191.676C49.3367 179.151 38.4329 168.258 33.2966 164.802C39.5979 169.914 43.909 185.989 45.2768 193.388C45.7003 192.952 46.2153 190.748 47.3159 190.413C48.7209 189.986 50.0456 190.983 50.9067 191.676Z",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_604_11485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 164,
    width: 18,
    height: 30
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9067 191.676C49.3367 179.15 38.4329 168.258 33.2966 164.802C39.5979 169.914 43.909 185.989 45.2768 193.388C45.7003 192.952 46.2153 190.748 47.3159 190.413C48.7209 189.986 50.0456 190.982 50.9067 191.676Z",
    fill: "#FC5C5C"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_604_11485)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_604_11485)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.6948,
    cy: 208.486,
    rx: 20.644,
    ry: 12.1938,
    transform: "rotate(-16.9111 50.6948 208.486)",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_604_11485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 165,
    width: 10,
    height: 33
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7802 197.187C27.1127 185.907 30.1081 170.789 32.4515 165.059C30.0619 172.813 35.4282 188.567 38.4101 195.475C37.8157 195.349 36.1609 193.804 35.0603 194.139C33.6554 194.566 33.1096 196.132 32.7802 197.187Z",
    fill: "#FC5C5C"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_604_11485)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_604_11485)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.644,
    cy: 12.1938,
    rx: 20.644,
    ry: 12.1938,
    transform: "matrix(-0.956757 0.290888 0.290888 0.956757 58.5166 193.361)",
    fill: "white"
  })))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.0264,
    cy: 119.385,
    rx: 19.5075,
    ry: 5.19733,
    transform: "rotate(-16.9111 19.0264 119.385)",
    fill: "url(#paint2_linear_604_11485)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1722 113.253C37.3235 113.751 37.1108 114.43 36.3672 115.289C35.6378 116.132 34.4687 117.06 32.9314 118.015C29.8614 119.92 25.3957 121.884 20.2631 123.445C15.1305 125.005 10.3276 125.859 6.71637 125.985C4.90801 126.048 3.41988 125.927 2.34497 125.633C1.24915 125.334 0.694057 124.887 0.542744 124.39C0.391431 123.892 0.604156 123.212 1.34771 122.353C2.07708 121.511 3.24618 120.582 4.78353 119.628C7.85352 117.722 12.3192 115.758 17.4518 114.198C22.5844 112.637 27.3874 111.783 30.9986 111.657C32.8069 111.595 34.295 111.715 35.37 112.009C36.4658 112.309 37.0209 112.755 37.1722 113.253Z",
    stroke: "white",
    strokeWidth: 0.7301
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_604_11485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 202,
    width: 39,
    height: 16
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1679 204.085C66.0029 206.831 58.3236 211.598 48.0158 214.732C37.708 217.866 28.6749 218.18 27.84 215.434C27.005 212.688 34.6843 207.921 44.9921 204.787C55.2999 201.653 64.333 201.339 65.1679 204.085Z",
    fill: "#FFF5E9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_604_11485)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_604_11485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 155,
    width: 41,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.9209,
    y: 166.367,
    width: 39.0151,
    height: 8.85888,
    transform: "rotate(-16.9111 12.9209 166.367)",
    fill: "#E74747"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_604_11485)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_604_11485)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.6971,
    cy: 151.191,
    rx: 11.9852,
    ry: 7.07926,
    transform: "rotate(-16.9111 28.6971 151.191)",
    fill: "#FFBB00"
  })))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3745 179.208C21.8604 176.909 23.4407 173.459 23.4407 169.603C23.4407 162.68 18.3476 157.067 12.0651 157.067C5.78252 157.067 0.420898 162.68 0.420898 169.603C0.420898 174.824 2.14657 179.3 6.26574 181.185C3.74421 183.588 3.02639 187.22 3.02639 191.284C3.02639 198.52 8.67042 204.386 14.953 204.386C21.2355 204.386 26.3285 198.52 26.3285 191.284C26.3285 185.854 23.4608 181.196 19.3745 179.208Z",
    fill: "#B5B5B5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7442 183.457C73.3606 180.416 71.8828 177.31 69.3676 174.787C64.065 169.467 56.1595 168.751 51.71 173.186C47.2606 177.621 47.9521 185.529 53.2546 190.849C58.4552 196.066 66.1599 196.855 70.6519 192.699C72.2922 192.617 73.9587 192.186 74.447 190.965C74.9988 189.586 74.4304 186.27 73.7442 183.457Z",
    fill: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_604_11485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 170,
    width: 27,
    height: 26
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7442 183.457C73.3606 180.416 71.8828 177.31 69.3676 174.787C64.065 169.467 56.1595 168.751 51.71 173.186C47.2606 177.621 47.9521 185.529 53.2546 190.849C58.4552 196.066 66.1599 196.855 70.6519 192.699C72.2922 192.617 73.9587 192.186 74.447 190.965C74.9988 189.586 74.4304 186.27 73.7442 183.457Z",
    fill: "#946555"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_604_11485)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_604_11485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4437 202.669C42.4159 203.902 51.5002 196.819 52.734 186.846C53.9678 176.874 46.8839 167.79 36.9117 166.556C26.9395 165.322 17.8553 172.406 16.6215 182.378C15.3876 192.351 22.4715 201.435 32.4437 202.669Z",
    fill: "#666666"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_604_11485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 157,
    width: 27,
    height: 48
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3745 179.208C21.8604 176.909 23.4407 173.459 23.4407 169.603C23.4407 162.68 18.3476 157.067 12.0651 157.067C5.78252 157.067 0.420898 162.68 0.420898 169.603C0.420898 174.824 2.14657 179.3 6.26574 181.185C3.74421 183.588 3.02639 187.22 3.02639 191.284C3.02639 198.52 8.67042 204.386 14.953 204.386C21.2355 204.386 26.3285 198.52 26.3285 191.284C26.3285 185.854 23.4608 181.196 19.3745 179.208Z",
    fill: "#946555"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_604_11485)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_604_11485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1083 196.748C42.0745 197.988 51.1532 190.867 52.3863 180.844C53.6194 170.82 46.5398 161.689 36.5736 160.449C26.6075 159.209 17.5287 166.329 16.2957 176.353C15.0626 186.376 22.1422 195.507 32.1083 196.748Z",
    fill: "#666666"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 167.399,
    y: 34.6414,
    width: 2.28086,
    height: 23.9109,
    fill: "#848484"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4484 60.632L92.6727 41.1747C92.0698 34.568 97.2712 28.8704 103.905 28.8704H152.109C158.78 28.8704 163.993 34.6287 163.333 41.267L161.387 60.8114C161.157 63.1202 160.194 65.3074 158.207 66.505C154.178 68.9333 145.281 72.5549 128.058 72.5549C110.978 72.5549 101.959 68.993 97.7953 66.5655C95.6962 65.3416 94.6692 63.0518 94.4484 60.632Z",
    fill: "#434343"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M125.184 14.8594C127.212 14.0861 129.453 14.0798 131.485 14.8416L173.229 30.4884C175.791 31.4487 175.802 35.0693 173.245 36.0442L130.933 52.1771C128.905 52.9504 126.664 52.9567 124.632 52.1949L82.8874 36.5482C80.3251 35.5878 80.3149 31.9672 82.8717 30.9923L125.184 14.8594Z",
    fill: "#353535"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M174.414 31.041L174.414 33.4792",
    stroke: "#2E2E2E",
    strokeWidth: 1.43973
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6904 31.2512L81.6904 33.4792",
    stroke: "#2E2E2E",
    strokeWidth: 1.43973
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M125.184 12.5034C127.212 11.7301 129.453 11.7238 131.485 12.4856L173.229 28.1324C175.791 29.0928 175.802 32.7134 173.245 33.6882L130.933 49.8212C128.905 50.5944 126.664 50.6008 124.632 49.839L82.8874 34.1922C80.3251 33.2318 80.3149 29.6112 82.8717 28.6364L125.184 12.5034Z",
    fill: "#434343"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.65503,
    cy: 2.65503,
    r: 2.65503,
    transform: "matrix(1 0 0 -1 165.885 62.5725)",
    fill: "#848484"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47603 166.667L17.3829 162.194L31.1456 162.507L33.1752 169.246C33.1752 169.246 31.838 176.461 22.5396 179.315C19.988 180.098 18.0441 180.579 16.5666 180.865C13.6097 181.438 11.6617 179.442 11.003 176.5L10.3649 173.65L7.47603 166.667Z",
    fill: "#707070"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1228 162.495C31.384 163.361 25.3734 163.707 18.4686 165.824C8.49395 169.433 8.26228 168.554 8.00107 167.688C7.73985 166.821 4.29133 164.103 16.8977 160.613C24.8768 158.405 30.8616 161.628 31.1228 162.495Z",
    fill: "#656565"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5376 151.946L44.8407 153.797L33.5798 161.789L35.6094 168.527C35.6094 168.527 40.6991 173.77 49.9975 170.917C52.5491 170.134 54.4294 169.441 55.8147 168.849C58.587 167.663 59.1047 164.911 58.0297 162.097L56.9884 159.371L55.5376 151.946Z",
    fill: "#707070"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5747 161.765C33.8359 162.631 39.0202 159.544 45.925 157.427C56.2036 154.826 55.911 153.966 55.6498 153.1C55.3885 152.233 56.7529 148.039 44.3541 152.217C36.5063 154.861 33.3135 160.898 33.5747 161.765Z",
    fill: "#656565"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4952 161.534C29.3939 161.871 28.7711 163.041 29.1045 164.146L31.0353 170.549C31.3687 171.655 32.5317 172.277 33.633 171.94C34.2519 171.75 34.7195 171.297 34.9515 170.741C35.451 171.073 36.0894 171.187 36.7083 170.997C37.8099 170.659 38.4327 169.49 38.0993 168.384L36.1684 161.981C35.835 160.875 34.6721 160.253 33.5704 160.591C32.9516 160.781 32.4839 161.233 32.252 161.789C32.1737 161.737 32.0924 161.691 32.0077 161.65C31.553 161.43 31.017 161.374 30.4952 161.534Z",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_604_11485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 160,
    width: 10,
    height: 13
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4984 161.536C29.3964 161.874 28.7726 163.044 29.1056 164.149L31.0337 170.55C31.3666 171.655 32.5298 172.276 33.6318 171.938C34.251 171.748 34.7191 171.295 34.9515 170.739C35.4511 171.071 36.0897 171.184 36.709 170.994C37.8113 170.656 38.435 169.486 38.1021 168.381L36.174 161.98C35.8411 160.875 34.6779 160.253 33.5756 160.592C32.9563 160.782 32.4882 161.235 32.2559 161.791C32.1776 161.739 32.0962 161.693 32.0116 161.652C31.5567 161.432 31.0206 161.376 30.4984 161.536Z",
    fill: "#F57045"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_604_11485)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_604_11485)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.669,
    cy: 12.2186,
    rx: 20.669,
    ry: 12.2186,
    transform: "matrix(0.956008 -0.293352 0.288447 0.957499 16.5439 181.223)",
    fill: "white"
  })))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M196.957 226.966C203.332 212.08 172.556 191.528 154.849 188.338C110.306 180.313 131.886 215.663 144.668 222.544C154.849 228.025 186.208 252.07 196.957 226.966Z",
    fill: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_604_11485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 128,
    y: 187,
    width: 70,
    height: 52
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M196.957 226.966C203.332 212.08 172.556 191.528 154.849 188.338C110.306 180.313 131.886 215.663 144.668 222.544C154.849 228.025 186.208 252.07 196.957 226.966Z",
    fill: "#946555"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_604_11485)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_604_11485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.072 263.997C189.453 265.319 179.78 257.732 178.466 247.052C177.152 236.372 184.695 226.643 195.314 225.322C205.933 224 215.606 231.587 216.92 242.267C218.234 252.947 210.691 262.676 200.072 263.997Z",
    fill: "#666666"
  })))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.404 201.663C139.698 186.426 134.28 190.593 131.924 186.045C129.567 181.496 130.657 178.034 133.862 174.829C138.505 170.186 144.504 171.707 147.709 174.912C155.151 182.355 164.129 196.59 158.745 204.395C157.566 208.25 155.568 211.418 153.517 213.727C152.49 214.884 151.357 215.929 150.171 216.777C149.188 217.479 147.421 218.592 145.18 218.965C140.708 219.708 136.48 216.686 135.737 212.215C134.725 206.131 138.411 207.235 141.404 201.663Z",
    fill: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_604_11485",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 171,
    width: 31,
    height: 49
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.403 201.663C139.697 186.426 134.279 190.593 131.923 186.044C129.567 181.496 130.656 178.034 133.862 174.829C138.504 170.186 144.503 171.707 147.708 174.912C155.15 182.355 164.128 196.59 158.744 204.395C157.565 208.25 155.567 211.418 153.516 213.727C152.489 214.883 151.356 215.929 150.17 216.776C149.187 217.479 147.42 218.591 145.179 218.964C140.707 219.708 136.479 216.686 135.736 212.215C134.724 206.131 138.41 207.235 141.403 201.663Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_604_11485)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_604_11485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.78 172.796C129.814 174.037 120.735 166.916 119.502 156.893C118.269 146.869 125.349 137.738 135.315 136.498C145.281 135.258 154.36 142.378 155.593 152.402C156.826 162.425 149.747 171.556 139.78 172.796Z",
    fill: "#666666"
  })))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.269 209.639C126.345 203.22 119.481 204.39 114.369 204.055C109.257 203.719 106.858 200.996 105.772 196.595C104.199 190.22 108.603 185.873 113.004 184.787C123.223 182.266 147.679 187.566 151.575 196.21C154.265 199.212 155.943 202.561 156.859 205.51C157.317 206.987 157.626 208.498 157.738 209.951C157.831 211.156 157.869 213.244 157.029 215.355C155.354 219.567 150.581 221.623 146.369 219.947C140.638 217.666 143.49 215.082 140.269 209.639Z",
    fill: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_604_11485",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 184,
    width: 53,
    height: 37
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.269 209.639C126.345 203.22 119.481 204.39 114.369 204.055C109.257 203.719 106.858 200.996 105.772 196.595C104.199 190.22 108.603 185.873 113.004 184.787C123.223 182.266 147.679 187.566 151.575 196.21C154.265 199.212 155.943 202.561 156.859 205.51C157.317 206.987 157.626 208.498 157.738 209.951C157.831 211.156 157.869 213.244 157.029 215.355C155.354 219.567 150.581 221.623 146.369 219.947C140.638 217.666 143.49 215.082 140.269 209.639Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_604_11485)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_604_11485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.369 215.635C93.4031 216.875 84.3243 209.754 83.0912 199.731C81.8582 189.707 88.9378 180.576 98.9039 179.336C108.87 178.096 117.949 185.216 119.182 195.24C120.415 205.263 113.335 214.394 103.369 215.635Z",
    fill: "#666666"
  })))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.972 226.46C160.614 224.32 161.253 215.779 158.754 206.856C156.256 197.933 148.035 192.434 140.392 194.574C137.119 195.491 134.483 197.66 132.735 200.542C124.756 202.837 122.867 207.384 124.383 212.798C125.554 216.978 128.478 219.978 133.104 219.534C137.744 227.6 146.466 228.282 152.972 226.46Z",
    fill: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_604_11485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 194,
    width: 38,
    height: 34
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.972 226.46C160.614 224.32 161.253 215.779 158.754 206.856C156.256 197.933 148.035 192.434 140.392 194.574C137.119 195.491 134.483 197.66 132.735 200.542C124.756 202.837 122.867 207.384 124.383 212.798C125.554 216.978 128.478 219.978 133.104 219.534C137.744 227.6 146.466 228.282 152.972 226.46Z",
    fill: "#946555"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_604_11485)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_604_11485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.247 250.331C115.281 251.571 106.202 244.45 104.969 234.427C103.736 224.403 110.816 215.272 120.782 214.032C130.748 212.792 139.827 219.912 141.06 229.936C142.293 239.959 135.213 249.09 125.247 250.331Z",
    fill: "#666666"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_604_11485",
    x: -12.1845,
    y: 171.931,
    width: 116.994,
    height: 117.204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.1562,
    result: "effect1_foregroundBlur_604_11485"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_604_11485",
    x: 13.018,
    y: 177.756,
    width: 75.3536,
    height: 61.4601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.803,
    result: "effect1_foregroundBlur_604_11485"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_604_11485",
    x: 4.6352,
    y: 180.302,
    width: 75.3536,
    height: 61.4601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.803,
    result: "effect1_foregroundBlur_604_11485"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_604_11485",
    x: 6.82352,
    y: 133.35,
    width: 43.7475,
    height: 35.6816,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.1107,
    result: "effect1_foregroundBlur_604_11485"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_604_11485",
    x: -23.831,
    y: 126.104,
    width: 117.017,
    height: 117.017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.1562,
    result: "effect1_foregroundBlur_604_11485"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_604_11485",
    x: -24.1562,
    y: 119.996,
    width: 116.994,
    height: 117.204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.1562,
    result: "effect1_foregroundBlur_604_11485"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_604_11485",
    x: 2.14692,
    y: 156.073,
    width: 75.3624,
    height: 61.5719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.803,
    result: "effect1_foregroundBlur_604_11485"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_604_11485",
    x: 135.365,
    y: 182.22,
    width: 124.655,
    height: 124.879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.4761,
    result: "effect1_foregroundBlur_604_11485"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_604_11485",
    x: 79.0508,
    y: 96.0452,
    width: 116.994,
    height: 117.204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.1562,
    result: "effect1_foregroundBlur_604_11485"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_604_11485",
    x: 42.6397,
    y: 138.883,
    width: 116.994,
    height: 117.204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.1562,
    result: "effect1_foregroundBlur_604_11485"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_604_11485",
    x: 64.5176,
    y: 173.579,
    width: 116.994,
    height: 117.204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.1562,
    result: "effect1_foregroundBlur_604_11485"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_604_11485",
    x1: 39.4338,
    y1: 109.702,
    x2: 25.1852,
    y2: 115.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D6D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_604_11485",
    x1: 24.9014,
    y1: 228.688,
    x2: 89.4773,
    y2: 190.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_604_11485",
    x1: 22.9986,
    y1: 126.52,
    x2: 26.7297,
    y2: 110.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_604_11485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.1428,
    height: 56.1495,
    fill: "white",
    transform: "translate(81.6729 187.314)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduateCharacter);
export default __webpack_public_path__ + "static/media/graduateCharacter.0a50d7a0f207e2f3ef974cb8881ca201.svg";
export { ForwardRef as ReactComponent };